import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultIconViewerPage from './Pages/DefaultIconViewerPage';

const IconViewerRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route default>
                <DefaultIconViewerPage />
            </Route>
        </Switch>
    );
};

export default IconViewerRouter;
